import PropTypes from 'prop-types';
import React from 'react';
import { get, isEmpty } from 'lodash';
import EditModal from '../../common/modal/EditModal';
import RowDisplay from '../../common/RowDisplay';
import PersonalInformationForm from './PersonalInformationForm';
import { useAppContext } from '../../../context/context';
var PersonalInformationDisplay = function PersonalInformationDisplay(_ref) {
  var _ref$contact = _ref.contact,
    contact = _ref$contact === void 0 ? {} : _ref$contact,
    lastUpdate = _ref.lastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate;
  var nicknames = get(contact, 'nicknames') || [];
  var nicknamesDisplayValue = nicknames.join(', ');
  var _useAppContext = useAppContext(),
    fieldsConfig = _useAppContext.state.fieldsConfig;
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Name",
    size: "large",
    formName: "edit-person-info",
    editButtonId: "edit-name-btn",
    id: "edit-personal-modal",
    showEdit: get(fieldsConfig, 'namesSection.showEdit')
  }, /*#__PURE__*/React.createElement(PersonalInformationForm, {
    contact: contact,
    shouldShowLastUpdate: shouldShowLastUpdate
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: editSection,
    label: "Name",
    lastUpdate: lastUpdate,
    showLastUpdate: shouldShowLastUpdate
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "First"), /*#__PURE__*/React.createElement("p", {
    "data-test-element": "fname-display"
  }, get(contact, 'first_name', ''))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Last"), /*#__PURE__*/React.createElement("p", {
    "data-test-element": "lname-display"
  }, get(contact, 'last_name', ''))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Middle Initial"), /*#__PURE__*/React.createElement("p", {
    "data-test-element": "mname-display"
  }, get(contact, 'middle_name_initial', '--')))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Title"), /*#__PURE__*/React.createElement("p", null, get(contact, 'title', '--'))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Suffix"), /*#__PURE__*/React.createElement("p", null, get(contact, 'suffix', '--'))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Nickname", nicknames.length > 1 ? 's' : null), /*#__PURE__*/React.createElement("p", null, isEmpty(nicknamesDisplayValue) ? '--' : nicknamesDisplayValue)))));
};
PersonalInformationDisplay.propTypes = {
  contact: PropTypes.shape({
    middle_name_initial: PropTypes.string,
    nicknames: PropTypes.array,
    suffix: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool
};
PersonalInformationDisplay.defaultProps = {
  lastUpdate: {
    recently_updated_by_name: null,
    recently_updated_at: null
  },
  shouldShowLastUpdate: false
};
export default PersonalInformationDisplay;
//# sourceMappingURL=PersonalInformationDisplay.js.map